import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { StatusTable, STATUS } from "../components/polda/StatusTable";

export default function PoldaStatusPage() {
  const navigate = useNavigate();
  const [days, setDays] = useState("90");
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState("ALL");

  useEffect(() => {
    setData(null);
    api.get("/polda-status", { params: { days } }).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [days]);

  const rows = data ? data.rows.filter((r) => filter === "ALL" || r.status === filter) : [];
  const count = (s) => data?.rows.filter((r) => r.status === s).length || 0;

  return (
    <div className="space-y-6 max-w-[1400px]" data-testid="polda-status-page">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 fade-up">
        <div>
          <div className="eyebrow">Ditressiber Polda</div>
          <h1 className="mt-2 font-heading font-black tracking-tight text-3xl sm:text-4xl">Status Pengisian Polda</h1>
          <p className="mt-1 text-sm text-muted-foreground">Pantau Polda yang belum mengisi atau lama tidak memperbarui data almatsus Forensik, Direction Finder & Patroli Siber.</p>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <span className="text-muted-foreground">Batas tidak diperbarui</span>
          <Select value={days} onValueChange={setDays}>
            <SelectTrigger className="w-32" data-testid="status-days-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {["30", "60", "90", "180", "365"].map((d) => <SelectItem key={d} value={d}>{d} hari</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-5 border bg-card divide-x divide-y lg:divide-y-0">
        {["ALL", ...Object.keys(STATUS)].map((s) => (
          <button key={s} onClick={() => setFilter(s)} data-testid={`status-filter-${s.replace(/ /g, "-")}`}
            className={`p-4 text-left transition-colors ${filter === s ? "bg-primary text-primary-foreground" : "hover:bg-muted"}`}>
            <div className={`text-[11px] font-semibold uppercase tracking-[0.14em] ${filter === s ? "opacity-70" : "text-muted-foreground"}`}>{s === "ALL" ? "Semua Polda" : s}</div>
            <div className="mt-2 font-heading font-black text-3xl tabular-nums">{s === "ALL" ? data?.rows.length || 0 : count(s)}</div>
          </button>
        ))}
      </div>
      {!data ? (
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
      ) : (
        <StatusTable rows={rows} days={data.days} onOpen={(p) => navigate(`/data/polda_forensik?polda=${encodeURIComponent(p)}`)} />
      )}
    </div>
  );
}
